<section class="rcx-table" [formGroup]="hikeForm">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <label class="form-label">Applicable <b class="text-secondary">*</b></label>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="yesOption" name="applicable"
                                            [value]="true" formControlName="applicable"
                                            [class.disabled]="isAssesmentCompleted" />
                                        <label class="form-check-label" for="yesOption">Yes</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="radio" id="noOption" name="applicable"
                                            [class.disabled]="isAssesmentCompleted" [value]="false"
                                            formControlName="applicable" (change)="setHikeForm(undefined)" />
                                        <label class="form-check-label" for="noOption">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row g-3 mt-2">
                            <div class="col-md-3">
                                <label for="amount" class="form-label">Hike Type<b class="required">*</b></label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        <i class='bx bx-bar-chart-alt'></i>
                                    </span>
                                    <select class="form-select" id="amount" formControlName="type"
                                        placeholder="Select Hike" [class.readonly]="isAssesmentCompleted"
                                        [attr.disabled]="!hikeForm.value.applicable ? true : null">
                                        <option hidden [ngValue]="null">Choose...</option>
                                        <option value="AMOUNT">Hike in Amount</option>
                                        <option value="PERCENTAGE">Hike in Percentage</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label for="label" class="form-label">Value <b class="text-secondary">*</b></label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        {{ hikeForm.get('type')?.value === 'PERCENTAGE' ? '%' : '₹' }}
                                    </span>
                                    <input type="number" class="form-control ps-1" id="value" placeholder="Enter Value"
                                        [ngClass]="{'is-invalid': submitted && m.label.errors}" formControlName="value"
                                        autocomplete="off" [attr.disabled]="!hikeForm.value.applicable ? true : null"
                                        [class.readonly]="isAssesmentCompleted"
                                        [class.read]="employeeAssesment?.status === 'LONE_COMPLETED'">
                                    <div class="invalid-feedback" *ngIf="submitted && m.value.errors">
                                        <span *ngIf="m.value.errors.required">Please provide a valid label.</span>
                                        <span *ngIf="m.value.errors.pattern">Only numbers are allowed.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="label" class="form-label">Comment <b class="text-secondary">*</b></label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        <i class='bx bx-message-alt'></i>
                                    </span>
                                    <input type="text" class="form-control ps-1" id="label" placeholder="Enter Comment"
                                        [ngClass]="{'is-invalid': submitted && m.label.errors}"
                                        formControlName="reasonToHike" autocomplete="off"
                                        [attr.disabled]="!hikeForm.value.applicable ? true : null"
                                        [class.readonly]="isAssesmentCompleted"
                                        [class.read]="employeeAssesment?.status === 'LONE_COMPLETED'">
                                    <div class="invalid-feedback" *ngIf="submitted && m.label.errors">
                                        <span *ngIf="m.label.errors.required">Please provide a valid label.</span>
                                        <span *ngIf="m.label.errors.pattern">Only letters are allowed.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>